import fileImports from "servicestack/file-import/file-imports";

export default app =>
	app
		.component("fileImports", fileImports);
